/*
 * Author: Harper Yan
 * File Created: Thursday, 24-07-11 09:07 pm
 * Last Modified: Wednesday, 24-09-04 07:02 pm, by Harper Yan
 */

import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type DialogThemeOptions = {
  defaultProps?: ComponentsProps['MuiDialog'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialog'];
  variants?: ComponentsVariants<Theme>['MuiDialog'];
};

export const MuiDialog: DialogThemeOptions = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: '12px',
      background: '#1B1E27',
      minWidth: '320px',
      // maxHeight: '600px',
      maxWidth: '400px',
      overflowX: 'hidden',
    }),
  },
};
